


let debug = 0;
(function(){
  escapeRegExp = function(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  urlParam = function(name){
    var results = new RegExp('[\?&]' + escapeRegExp(name) + '=([^&#]*)').exec(window.location.href);
    if (results==null){
      name = 'attribute['+name+']';
      results = new RegExp('[\?&]' + escapeRegExp(name) + '=([^&#]*)').exec(window.location.href);
      if (results==null){
        return null;
      }
    }
		
    return results[1].replace(/[^\w-]/g, "").substring(0, 36) || 0;
  };

  getCookie = function (name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  updateCartAttributes = function(data, callback, redirect_user = false) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(cart) {

				

        if ((typeof callback) === 'function') {
          callback(cart);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
				
      },
      complete: function(jqxhr, text) {
        // Set the cookie that will expire in 60 minutes.
        if (redirect_user) {
          document.cookie = `qn_id=provided; path=/; max-age=${3600};`;
          
          var redirectUri = $('.global-redirect-page').attr('data-redirect-uri');
          // Redirect the user to the get started page.
           window.location = redirectUri 
        }
      }
    };
    $.ajax(params);
  };

  var qn_id = urlParam('qn_id');
  var attributes = [];

  if (qn_id){
    $('.loader').show();
    attributes.push('attributes[qn_id]='+encodeURIComponent(qn_id));
		
    var hashQNID = function(s) {
      var hash = 0,
        strlen = s.length,
        i,
        c;
      if ( strlen === 0 ) {
        return hash;
      }
      for ( i = 0; i < strlen; i++ ) {
        c = s.charCodeAt( i );
        hash = ((hash << 5) - hash) + c;
        hash = hash & hash; // Convert to 32bit integer
      }
      return 'qn_id'+hash;
    };
    var trackQNID = function(){
      if(typeof ga !== 'undefined') {
        var hashedQNID = hashQNID(qn_id);
        ga(
          'send',
          'event', 'ecommerce', 'orderid', hashedQNID, {
            'dimension01': hashedQNID
          }
        );
      }
      else {
        setTimeout(trackQNID, 500);
      }
    };
    trackQNID();
  }
  else {
    if (window.location.href.indexOf("get-started") > -1) {
      $('.content-for-layout').show();
    }
    else {
      $('.content-for-layout').show();
      $('.header-wrapper').show();
      $('.footer').show();
    }
  }

	

  if (attributes.length > 0) {
    updateCartAttributes(attributes.join('&'), null, true);
  }
  else {
    let qn_provided = getCookie('qn_id');
    if (qn_provided === 'provided') {
      return;
    }
    // Reset the questionnaire id:
    let reset_attributes = ["attributes[qn_id]=0"]
    updateCartAttributes(reset_attributes.join('&'), null);
  }

	

})();